import { getAllEvents, getEventCount, getMenus } from "../../src/lib/dataFetch";
import parse from "html-react-parser";
import { default as NextLink } from "next/link";
import { Stack, StackDivider } from "@chakra-ui/react";
import Layout from "../../src/components/layout";
import Seo from "../../src/components/seo";
import EventCard from "../../src/components/EventCard";

export default function EventsIndex({ events, menus, pageInfo }) {
  console.log(pageInfo);
  return (
    <Layout
      menus={menus}
      hasNext={pageInfo?.hasNextPage}
      hasPrevious={pageInfo?.hasPreviousPage}
      startCursor={pageInfo?.startCursor}
      endCursor={pageInfo?.endCursor}
    >
      <Seo title="Upcoming Events" />
      <Stack
        as="ol"
        divider={<StackDivider borderColor="gray.200" />}
        spacing={4}
        mb={4}
        p={8}
        listStyleType="none"
      >
        {events.map((event, index) => {
          const title = event.title;
          const featuredImage = {
            src: event.featuredImage?.node?.sourceUrl,
            alt: event.featuredImage?.node?.alt || ``,
          };

          return (
            <>
              <EventCard
                key={event.uri}
                title={title}
                featuredImage={featuredImage}
                uri={event.uri}
                categories={event.eventsCategories.nodes}
                excerpt={event.excerpt}
                date={event.startDate}
              />
            </>
          );
        })}
      </Stack>
    </Layout>
  );
}
export async function getStaticProps(context) {
  const data = await getAllEvents();
  const menus = await getMenus();
  const eventsSorted = data.events.sort((a, b) => {
    let da = new Date(a.startDate);
    let db = new Date(b.startDate);
    return da - db;
  });
  const events = eventsSorted.slice(0, 10);
  const pageInfo = {
    __typename: "WPPageInfo",
    hasNextPage: true,
    hasPreviousPage: false,
    startCursor: null,
    endCursor: null,
  }
  return {
    props: {
      events,
      menus,
      pageInfo,
    },
  };
}
